import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { AppConfigService } from '@aperza/util';
export default class SuggestPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSuggest: false,
        };
    }
    onClick() {
        const isSearchResult = AppConfigService.isAperzaSearchResultPage();
        const isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();
        if (!isSearchResult && !isSearchNewsResult) {
            if (this.props.onClick) {
                this.props.onClick();
            }
        }
    }
    onMouseOver(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    render() {
        const { suggest } = this.props;
        const { showSuggest } = this.state;
        const isSearchResult = AppConfigService.isAperzaSearchResultPage();
        const isSearchNewsResult = AppConfigService.isAperzaSearchNewsResultPage();
        let suggestPopUpStyle = {
            display: showSuggest ? 'block' : 'none',
        };
        suggestPopUpStyle = {
            display: 'none',
        };
        return (React.createElement("div", { className: "suggest-popup" },
            React.createElement("div", { className: clsx('suggest-popup-button', {
                    inactive: showSuggest || isSearchResult || isSearchNewsResult,
                }), onClick: this.onClick.bind(this) },
                React.createElement("i", { className: "fa fa-search", "aria-hidden": "true" })),
            React.createElement("div", { className: "suggest-popup-modal", style: suggestPopUpStyle, onMouseOver: this.onMouseOver.bind(this) }, suggest)));
    }
}
SuggestPopUp.propTypes = {
    suggest: PropTypes.any.isRequired,
    onClick: PropTypes.func,
};
